import SpecList from './ComposedSpecList';
import SpecListQuery from './SpecListQuery.graphql';

SpecList.query = SpecListQuery;

export default SpecList;
